var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/site-logo.tsx";
const _excluded = ["className", "theme"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
import { useSoapboxConfig, useSettings, useTheme } from 'soapbox/hooks';

/** Display the most appropriate site logo based on the theme and configuration. */
const SiteLogo = _ref => {
  let {
    className,
    theme
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const {
    logo,
    logoDarkMode
  } = useSoapboxConfig();
  const settings = useSettings();
  const darkMode = useTheme() === 'dark';
  /** Soapbox logo. */

  const soapboxLogo = darkMode ? require('assets/images/soapbox-logo-white.svg') : require('assets/images/soapbox-logo.svg'); // Use the right logo if provided, then use fallbacks.

  const getSrc = () => {
    // In demo mode, use the Soapbox logo.
    if (settings.get('demo')) return soapboxLogo;
    return darkMode && logoDarkMode ? logoDarkMode : logo || logoDarkMode || soapboxLogo;
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/alt-text
    React.createElement("img", _extends({
      className: classNames('object-contain', className),
      src: getSrc()
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 5
      }
    }))
  );
};

export default SiteLogo;